/**
 * Cap unread counts at 999. Anything above renders as `999+`. Zero
 * returns the empty string so callers can branch on truthiness.
 *
 * Single source of truth for sidebar Messages total, per-row
 * channel/DM badge, and per-thread "View Threads" badge so the three
 * surfaces always agree on the cap behavior.
 */
export function unreadLabel(count: number): string {
  if (count <= 0) return ''
  if (count > 999) return '999+'
  return String(count)
}
